var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166504 19C0.166504 8.8748 8.37462 0.666687 18.4998 0.666687C28.6251 0.666687 36.8332 8.8748 36.8332 19C36.8332 29.1252 28.6251 37.3334 18.4998 37.3334C8.37462 37.3334 0.166504 29.1252 0.166504 19ZM18.4998 4.00002C10.2156 4.00002 3.49984 10.7157 3.49984 19C3.49984 27.2843 10.2156 34 18.4998 34C26.7841 34 33.4998 27.2843 33.4998 19C33.4998 10.7157 26.7841 4.00002 18.4998 4.00002Z",
    fill: "#0258FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4998 7.33335C19.4203 7.33335 20.1665 8.07955 20.1665 9.00002V19C20.1665 19.9205 19.4203 20.6667 18.4998 20.6667C17.5794 20.6667 16.8332 19.9205 16.8332 19V9.00002C16.8332 8.07955 17.5794 7.33335 18.4998 7.33335Z",
    fill: "#0258FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33317 19C9.33317 18.0795 10.0794 17.3334 10.9998 17.3334H18.4998C19.4203 17.3334 20.1665 18.0795 20.1665 19C20.1665 19.9205 19.4203 20.6667 18.4998 20.6667H10.9998C10.0794 20.6667 9.33317 19.9205 9.33317 19Z",
    fill: "#0258FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.a95fe71e.svg";
export { ForwardRef as ReactComponent };